"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propType = exports.default = exports.Region = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Component = require("../Component");
var _propTypes2 = require("../prop-types");
const _excluded = ["region", "className"];
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * This PropType represents a `region` object from the ShopperExperience API.
 */
const propType = exports.propType = _propTypes.default.shape({
  id: _propTypes.default.string,
  components: _propTypes.default.arrayOf(_propTypes2.componentPropType)
});
/**
 * This component will render a page designer region given its serialized data object.
 *
 * @param {RegionProps} props
 * @param {Region} props.region - The page designer region data representation.
 * @returns {React.ReactElement} - Region component.
 */
const Region = props => {
  const {
      region,
      className = ''
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    id,
    components
  } = region;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    id: id,
    className: `region ${className}`
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, components === null || components === void 0 ? void 0 : components.map(component => /*#__PURE__*/_react.default.createElement(_Component.Component, {
    key: component.id,
    component: component
  }))));
};
exports.Region = Region;
Region.displayName = 'Region';
Region.propTypes = {
  region: propType.isRequired,
  className: _propTypes.default.string
};
var _default = exports.default = Region;